// Get all the .fav-container elements
let $favContainers = document.querySelectorAll('.fav-container');

// Loop through each fav-container
$favContainers.forEach(($favContainer) => {
    // Get the form inside fav-container
    let $form = $favContainer.querySelector('.form-wishlist');

    if (!$form) {
        // Simulate submit when clicking on the button if form is not present
        let $button = $favContainer.querySelector('.favourite-button');
        if ($button) {
            $button.addEventListener('click', async (e) => {
                e.preventDefault();
                let $inputs = $favContainer.querySelectorAll('input');
                if ($inputs.length > 0) {
                    let formData = new FormData();
                    // Append each input's name and value to the FormData
                    $inputs.forEach(($input) => {
                        formData.append($input.name, $input.value);
                    });
                    await submitForm(formData);
                    $button.classList.toggle('active');

                    // toggle action value
                    let $actionInput = $favContainer.querySelector('input[name="action"]');
                    if ($actionInput) {
                        $actionInput.value =
                            $actionInput.value === 'wishlist/items/add'
                                ? 'wishlist/items/remove'
                                : 'wishlist/items/add';
                    }
                } else {
                    let $actionUrl = $button.getAttribute('data-action-url');
                    if ($actionUrl) {
                        window.location.href = $actionUrl;
                    } else {
                        console.error('Action URL not found');
                    }
                }
            });
        }
    }
});

// Handle actual form submissions
let $addToWishListForms = document.querySelectorAll('.form-wishlist');
$addToWishListForms.forEach(($form) => {
    $form.addEventListener('submit', async (e) => {
        e.preventDefault();
        let $formData = new FormData($form);
        await submitForm($formData);

        // Toggle button state
        let $button = $form.querySelector('button');
        if ($button) {
            $button.classList.toggle('active');
        }

        // Toggle action value
        let $actionInput = $form.querySelector('input[name="action"]');
        if ($actionInput) {
            $actionInput.value =
                $actionInput.value === 'wishlist/items/add'
                    ? 'wishlist/items/remove'
                    : 'wishlist/items/add';
        }
    });
});

// Function to submit the form
const submitForm = async ($formData) => {
    try {

        let response = await fetch('/', {
            method: 'post',
            body: $formData,
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        let result = await response.json();
        console.log(result);
    } catch (error) {
        console.error('Error submitting form:', error);
    }
};
